export default {
    // --------Title--------
    fullDetailsOfBusinessProfile: '企业完整信息',
    fullAddressDetailsOfBusinessInformation: '企业完整的地址信息',
    
    // --------MUI--------
    idNo: '注册号码',
    idNumber: '注册号码',
    website: '网址',

};